module.exports = __webpack_public_path__ + "img/login_bg_center.02b4018c.png";